import { Component, Input } from "@angular/core";
import { BonusService } from "src/app/services/bonus/bonus.service";
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from "src/app/services/config/config.service";
import { LobbyNavigator } from "src/app/services/lobby/lobby-navigator.service";
import { IPromotion } from "src/app/interfaces/player-dashboard.interface";
import { PopoverController } from "@ionic/angular";

@Component({
    selector: 'app-popover-promotion-details',
    templateUrl: './popover-promotion-details.component.html',
    styleUrls: ['./popover-promotion-details.component.scss'],
})
export class PromotionDetailsPopoverComponent {
    @Input() data: IPromotion;

    public get promotion(): IPromotion {
        return this.data;
    }

    constructor (
        private popOverCtrl: PopoverController,
        private bonusService: BonusService,
        private navigator: Navigator,
        public config: ConfigService,
        private lobbyNavigator: LobbyNavigator
    ) {}

    public moreInfo() {
        this.bonusService.setPromoDetailInfo({ id: this.promotion.id });
        this.navigator.dismissAll('');
        this.lobbyNavigator.navigateToPromotionsWebOrMobile();
    }

    public closePopover() {
        try{
            this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
        }catch(e){
            console.log("Popover Close Error",e)
            this.popOverCtrl.dismiss();
        }
    }
}